import * as yup from "yup";

export const ValidationSchema = yup.object().shape({});
